
<div class="text-center" *ngIf="this.serviceDetails.loading">
    <div class="loader"></div>
</div>

<div class="themeAlert danger" *ngIf="this.serviceDetails.error">
    {{this.serviceDetails.error}}
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!this.serviceDetails.loading && !this.serviceDetails.error">
    <div class="addserfrm">
        <app-main-heading [title]="this.formTitle"></app-main-heading>
        <div class="productPoup">
            <div class="prodpop-left">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="inputGroup">
                            <input maxlength="64" type="text"
                                formControlName="productName" [readonly]="this.viewMode"
                                class="inputBox {{form.get('productName')?.errors && form.get('productName')?.touched ? 'border-danger' : ''}}"
                                id="serviceName" placeholder="" />
                            <label for="serviceName" class="inputLabel popInLabel">Service Name</label>
                            <small class="text-right d-block">{{countChars(form.get('productName')?.value)}}/64</small>

                            <small class="text-danger"
                                *ngIf="form.get('productName')?.hasError('required') && form.get('productName')?.touched">
                                Service Name is required.
                            </small>
                            <small class="text-danger"
                                *ngIf="form.get('productName')?.hasError('maxlength') && form.get('productName')?.touched">
                                Service name can't be more than
                                {{form.get('productName')?.errors?.['maxlength']?.requiredLength}} chars.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="inputGroup">
                            <textarea id="serreg" formControlName="description" [readonly]="this.viewMode"
                                maxlength="80"
                                class="inputBox regTextarea prodModelAreaheight servicelstpopup {{form.get('description')?.errors && form.get('description')?.touched ? 'border-danger' : ''}}"
                                rows="8" placeholder=""></textarea>
                            <label for="serreg" class="inputLabel popInLabel">Service Description</label>
                            <small class="text-right d-block">{{countChars(form.get('description')?.value)}}/80</small>

                            <small class="text-danger"
                                *ngIf="form.get('description')?.hasError('required') && form.get('description')?.touched">
                                Description is required.
                            </small>
                            <small class="text-danger"
                                *ngIf="form.get('description')?.hasError('maxlength') && form.get('description')?.touched">
                                Description can't be more than
                                {{form.get('description')?.errors?.['maxlength']?.requiredLength}} chars.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="inputGroup">
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">
                                <mat-label class="matLabel">Category </mat-label>
                                <input *ngIf="this.viewMode" matInput
                                    [value]="this.serviceDetails.response.categoryName" [readonly]="true">
                                <mat-select formControlName="categoryId" *ngIf="!this.viewMode">
                                    <mat-option [value]="" *ngIf="categoryList.loading"><i>Loading ...</i></mat-option>
                                    <mat-option *ngFor="let category of categoryList.response" [value]="category.id">
                                        {{ category.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger"
                                *ngIf="form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched">
                                Category is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="inputGroup">
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">
                                <mat-label class="matLabel">Sub-Category </mat-label>
                                <input *ngIf="this.viewMode" matInput
                                    [value]="this.serviceDetails.response.subCategoryName" [readonly]="true">
                                <mat-select formControlName="subCategoryId" *ngIf="!this.viewMode">
                                    <mat-option [value]="" *ngIf="subCategoryList.loading"><i>Loading
                                            ...</i></mat-option>
                                    <mat-option *ngFor="let subCategory of subCategoryList.response"
                                        [value]="subCategory.id">
                                        {{ subCategory.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger"
                                *ngIf="form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched">
                                Sub Category is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="inputGroup">
                            <input (keypress)="this.allowOnlyNumeric($event)" type="tel" formControlName="price"
                                maxlength="6" [readonly]="this.viewMode"
                                class="inputBox {{form.get('price')?.errors && form.get('price')?.touched ? 'border-danger' : ''}}"
                                id="price" placeholder="" />
                            <label for="price" class="inputLabel popInLabel">MRP
                            </label>
                            <small class="text-danger d-block text-start"
                                *ngIf="form.get('price')?.hasError('required') && form.get('price')?.touched">
                                Price is required.
                            </small>
                            <small class="text-danger errorFixed d-block text-start"
                            *ngIf="form.get('price')?.hasError('min') && form.get('price')?.touched">
                            Price can't be 0.
                        </small>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="inputGroup">
                            <input (keypress)="this.allowOnlyNumeric($event)" type="tel" [readonly]="this.viewMode"
                                formControlName="discountedPrice" maxlength="6"
                                class="inputBox {{form.get('discountedPrice')?.errors && form.get('discountedPrice')?.touched ? 'border-danger' : ''}}"
                                id="discountedPrice" placeholder="" />
                            <label for="discountedPrice" class="inputLabel popInLabel">Discounted Price
                            </label>
                            <small class="text-danger d-block text-start"
                                *ngIf="form.get('discountedPrice')?.hasError('required') && form.get('discountedPrice')?.touched">
                                Discounted is required.
                            </small>
                            <small class="text-danger d-block text-start"
                            *ngIf="form.get('discountedPrice')?.hasError('moreThanPrice') && form.get('discountedPrice')?.touched">
                            Must be less than MRP.
                        </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="prodpop-right">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="inputGroup">
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('serviceTypes')?.hasError('required') && form.get('serviceTypes')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">
                                <mat-label class="matLabel">Service Type </mat-label>
                                <input *ngIf="this.viewMode" matInput
                                    [value]="this.selectedServiceTypesToShow(selectedServiceTypes)" [readonly]="true">
                                <mat-select formControlName="serviceTypes" [(ngModel)]="selectedServiceTypes"
                                    [compareWith]="comparer" *ngIf="!this.viewMode" multiple>
                                    <mat-option [value]="{ id: '' }" *ngIf="servTypeList.loading"><i>Loading
                                            ...</i></mat-option>
                                    <mat-option *ngFor="let servicetype of servTypeList.response" [value]="servicetype">
                                        {{ servicetype.name }}
                                    </mat-option>
                                </mat-select>

                            </mat-form-field>
                            <small class="text-danger"
                                *ngIf="form.get('serviceTypes')?.hasError('required') && form.get('serviceTypes')?.touched">
                                Service type is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="inputGroup">
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('appointmentFlag')?.hasError('required') && form.get('appointmentFlag')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">
                                <mat-label class="matLabel">Appointment </mat-label>
                                <input *ngIf="this.viewMode" matInput
                                    [value]="this.serviceDetails.response.appointmentFlag === 'Y' ? 'Yes' : 'No'"
                                    [readonly]="true">
                                <mat-select formControlName="appointmentFlag" *ngIf="!this.viewMode">
                                    <mat-option [value]="" *ngIf="appointmentList.loading"><i>Loading
                                            ...</i></mat-option>
                                    <mat-option *ngFor="let appointment of appointmentList.response"
                                        [value]="appointment.id">
                                        {{ appointment.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger"
                                *ngIf="form.get('appointmentFlag')?.hasError('required') && form.get('appointmentFlag')?.touched">
                                Appointment is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="inputGroup">
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('statusId')?.errors && form.get('statusId')?.touched ? 'border-danger' :''}}"
                                appearance="outline">
                                <mat-label class="matLabel">Status </mat-label>
                                <input *ngIf="this.viewMode" matInput [value]="this.serviceDetails.response.status"
                                    [readonly]="true">
                                <mat-select formControlName="statusId" *ngIf="!this.viewMode">
                                    <mat-option *ngFor="let status of statusList.response" [value]="status.id">
                                        {{ status.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger d-block text-start"
                                *ngIf="form.get('statusId')?.hasError('required') && form.get('statusId')?.touched">
                                Status is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="inputGroup">
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('variantOption1')?.errors && form.get('variantOption1')?.touched ? 'border-danger' :''}}"
                                appearance="outline">
                                <mat-label class="matLabel">Duration </mat-label>
                                <input *ngIf="this.viewMode" matInput
                                    [value]="this.serviceDetails.response.variantOption1" [readonly]="true">
                                <mat-select formControlName="variantOption1" *ngIf="!this.viewMode">
                                    <mat-option [value]="" *ngIf="serviceDurationList.loading"><i>Loading
                                            ...</i></mat-option>
                                    <mat-option *ngFor="let duration of serviceDurationList.response"
                                        [value]="duration.name">
                                        {{ duration.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger d-block text-start"
                                *ngIf="form.get('variantOption1')?.hasError('required') && form.get('variantOption1')?.touched">
                                Duration is required.
                            </small>
                        </div>
                    </div>

                    <div class="col-lg-8">
                        <div class="inputGroup">
                            <input onkeydown="return /[a-z0-9 ]/i.test(event.key)" maxlength="64" type="text"
                                [readonly]="this.viewMode" formControlName="requirement"
                                class="inputBox {{form.get('requirement')?.errors && form.get('requirement')?.touched ? 'border-danger' : ''}}"
                                id="requirement" placeholder="" />
                            <label for="requirement" class="inputLabel popInLabel">Requirement</label>
                            <small class="text-danger"
                                *ngIf="form.get('requirement')?.hasError('required') && form.get('requirement')?.touched">
                                Requirement is required.
                            </small>
                            <small class="text-danger"
                                *ngIf="form.get('requirement')?.hasError('maxlength') && form.get('requirement')?.touched">
                                Requirement can't be more than
                                {{form.get('requirement')?.errors?.['maxlength']?.requiredLength}} chars.
                            </small>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="imgUploadTitle">Upload Product photo</div>
                        <div class="imageUploadSec">

                            <div class="imageUpload foradd me-2" *ngFor="let ml of mediaList?.value; index as k">
                                <label formArrayName="mediaList" class="d-flex justify-content-center" for="sml{{k}}"
                                    class="llb100 {{!ml?.src && k === 0 && form.get('mediaList')?.touched ? 'border-danger' : ''}}">
                                    <input hidden *ngIf="!this.uploadingFile && !this.viewMode" type="file"
                                        id="sml{{k}}" accept=".png,.jpg,.jpeg"
                                        (input)="this.uploadFile($event.target, 'media', k)" />
                                    <!-- <img src="{{ml?.src}}"
                                        *ngIf="!(this.uploadingMediaIndex === k && this.uploadingFile)"
                                        onerror="this.src = '../../../assets/images/upload-img.svg';" alt=""
                                          /> -->

                                    <div class="uplgimgblk"
                                        *ngIf="!(this.uploadingMediaIndex === k && this.uploadingFile)">
                                        <img src="{{ml?.src}}" *ngIf="ml?.src" (click)="onPreview(ml?.src, 1)" alt="" class="imguploded" />
                                        <img src="../../../assets/images/upload-img.svg" *ngIf="!(ml?.src)" alt=""
                                            class="imgdefault" />
                                    </div>
                                    <div *ngIf="this.uploadingMediaIndex === k">
                                        <div class="loader"></div>
                                    </div>
                                </label>
                                <button class="imgdel" *ngIf="ml?.src && !this.viewMode" (click)="this.removeMedia(k)">
                                    <img src="./assets/images/trash-icon.svg" alt="" />
                                </button>
                            </div>

                        </div>
                        <div class="imgUploadText" *ngIf="!this.viewMode">
                            *Recommended resolution is 640×640 with file size {{this.allowedFileSizeToUpload}} MB
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center d-block mb-2" *ngIf="this.viewMode">
            <div class="btnbx modPopBtns mt-3" *ngIf="!(this.serviceDetails.response?.validationStatus === 'Approved')">
                <div class="btnThemeOutline blue me-3 modelPopup-btn" *ngIf="this.serviceDetails.response?.validationStatus === 'Rejected'"
                [style.opacity]="0.5" [style.cursor]="'not-allowed'">
                <span *ngIf="!rejectLoader">Reject</span>
                <div *ngIf="rejectLoader" class="small loader"></div>
              </div>

                <div role="button" class="btnThemeOutline blue me-3 modelPopup-btn"
                *ngIf="!(this.serviceDetails.response?.validationStatus === 'Rejected')"
                    (click)="handleProductReject(this.form.get('id')?.value)">
                    <span *ngIf="!rejectLoader">Reject</span>
                    <div *ngIf="rejectLoader" class="small loader"></div>
                </div>
                <div role="button" class="gredientOutLineBtn">
                    <div class="btnContent modelPopup-btn"
                        (click)="handleProductApprove(this.form.get('id')?.value)">
                        <span *ngIf="!approveLoader">Approve</span>
                        <div *ngIf="approveLoader" class="small loader"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center" *ngIf="!this.viewMode">
            <div class="btnbx modPopBtns mt-5">
                <button class="btnThemeOutline blue me-3 modelPopup-btn"
                    [disabled]="this.submitLoading || this.uploadingFile" (click)="this.handleReset($event)">
                    Cancel
                </button>
                <button class="gredientOutLineBtn" [disabled]="this.submitLoading || this.uploadingFile">
                    <!-- <div class="loader" *ngIf="this.submitLoading"></div>
                    <div class="btnContent modelPopup-btn" *ngIf="!this.submitLoading">Update</div> -->
                    <div class="btnContent modelPopup-btn">
                        <div class="loader small" *ngIf="this.submitLoading"></div>
                        <div *ngIf="!this.submitLoading">Update</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</form>


